import { propertyHasCustomManualAdjustments } from '@aloft/toolkit-shared';
import { Button, Flex, Typography } from '@aloft/toolkit-sui';

import { GuidedTourTooltip } from '../../../components/GuidedTour/GuidedTourTooltip.tsx';
import { IndicatedValueInformationIcon } from '../../../components/IndicatedValueInformationIcon.tsx';
import { selectManualAdjustmentsById } from '../../../redux/features/selectors/propertyDataSelectors/manualAdjustmentsSelectors.ts';
import { selectFirstOrFewerCompID } from '../../../redux/features/selectors/selectFirstOrFewerCompID.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { PLACEHOLDER } from '../consts.ts';
import { selectPropertyValueDisplayById } from '../../../redux/features/selectors/selectPropertyValue.ts';

type HeaderProps = {
  id: string;
  onModeToggle: () => void;
  editMode: 'objective' | 'subjective';
  disableEdit: boolean;
};

export const Header = ({ id, onModeToggle, editMode, disableEdit }: HeaderProps) => {
  const secondOrFewerCompID = useAppSelector(selectFirstOrFewerCompID);
  const { id: _id, ...manualAdjustments } =
    useAppSelector((state) => selectManualAdjustmentsById(state, id)) ?? {};

  const propertyValue = useAppSelector((state) => selectPropertyValueDisplayById(state, id));

  return (
    <Flex
      backgroundColor="alertInfoLight"
      alignItems="center"
      justifyContent="space-between"
      gap="0.5rem"
      padding="0.5rem"
      height="2.25rem"
    >
      <Flex gap=".5rem" alignItems="center">
        <Typography variant="h4">{`Indicated Cost Value: ${propertyValue ?? PLACEHOLDER}`}</Typography>
        <IndicatedValueInformationIcon propertyId={id} compIsManuallyAdjusted={propertyHasCustomManualAdjustments(manualAdjustments)} />
      </Flex>
      {editMode === 'subjective' && (
        <GuidedTourTooltip
          text="If you need to add, remove or edit property features, click on the ‘Edit’ button on any property."
          tourID="analysisTour"
          tourIndex={2}
          displayCondition={id === secondOrFewerCompID}
          placement="bottom"
        >

          <Button
            variant="secondary"
            size="sm"
            onClick={onModeToggle}
            text="Edit"
            onMouseDown={(e) => {
              // Prevent focus change
              e.preventDefault();
            }}
            disabled={disableEdit}
          />
        </GuidedTourTooltip>
      )}
    </Flex>
  );
};
